/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NetConnectWifiIcon16Light } from './NetConnectWifiIcon16Light';
import { NetConnectWifiIcon16Regular } from './NetConnectWifiIcon16Regular';
import { NetConnectWifiIcon16Solid } from './NetConnectWifiIcon16Solid';
import { NetConnectWifiIcon20Light } from './NetConnectWifiIcon20Light';
import { NetConnectWifiIcon20Regular } from './NetConnectWifiIcon20Regular';
import { NetConnectWifiIcon20Solid } from './NetConnectWifiIcon20Solid';
import { NetConnectWifiIcon24Regular } from './NetConnectWifiIcon24Regular';
import { NetConnectWifiIcon24Solid } from './NetConnectWifiIcon24Solid';
import { NetConnectWifiIcon32Regular } from './NetConnectWifiIcon32Regular';
import { NetConnectWifiIcon64Regular } from './NetConnectWifiIcon64Regular';
var sizes = {
    16: {
        light: NetConnectWifiIcon16Light,
        regular: NetConnectWifiIcon16Regular,
        solid: NetConnectWifiIcon16Solid,
    },
    20: {
        light: NetConnectWifiIcon20Light,
        regular: NetConnectWifiIcon20Regular,
        solid: NetConnectWifiIcon20Solid,
    },
    24: {
        regular: NetConnectWifiIcon24Regular,
        solid: NetConnectWifiIcon24Solid,
    },
    32: {
        regular: NetConnectWifiIcon32Regular,
    },
    64: {
        regular: NetConnectWifiIcon64Regular,
    },
};
export var NetConnectWifiIcon = forwardRef('NetConnectWifiIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
